<!-- Seit 01.10.2026 der Orbi-Loader (Ladezustände-Regel, CLAUDE.md Regel 19):
     vorher eine 70px-Kachel mit Nebular-Spinner. Alle Aufrufer bekommen ihn
     ohne Änderung; `[label]` ist optional. -->
<app-orbi-loader class="page-loading" [label]="label"></app-orbi-loader>
